import { Directive } from '@angular/core'
import { FloFetchFillDirective } from '@flosportsinc/ng-fetch-fill'

@Directive({
  selector: '[floFetchGeo]'
})
export class GeoIPDirective extends FloFetchFillDirective<any, any, any, any> {
  floFetchFill = 'geo'
}
